import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalrequestabandonedvideo-card',
  templateUrl: './helpbutton-reports-totalrequestabandonedvideo-card.component.html',
  styleUrls: ['./helpbutton-reports-totalrequestabandonedvideo-card.component.scss']
})
export class HelpbuttonReportsTotalrequestabandonedvideoCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
